<template>
  <div class="numone">
    <!-- 右上角切换注册方式盒子 -->
    <!-- <div class="change" >
    <div   @click="changetry()">
      <div v-if="changeshow" class="cursorPointer">机构注册</div>
      <div v-if="!changeshow" class="cursorPointer">个人注册</div>
    </div>
  </div> -->
    <!-- 下方内容显示盒子 -->
    <div>
      <el-tabs type="border-card" v-model="activeName">
        <el-tab-pane label="个人注册" name="user">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <!-- <el-form-item>
      <div class="title"  >
        <div v-if="titleshow">个人注册</div>
        <div v-if="!titleshow">机构注册</div>
      </div>
    </el-form-item> -->

            <!-- 个人注册方式表单div -->
            <el-form-item prop="mobile">
              <el-input v-model="ruleForm.mobile" autocomplete="off" placeholder="请输入手机号"
                prefix-icon="el-icon-user-solid"></el-input>
            </el-form-item>
            <!-- 待定义 -->
            <el-form-item prop="password">
              <el-input type="password" v-model="ruleForm.password" autocomplete="new-password"
                placeholder="请输入6-14位数字与字母密码" prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <!-- 待增加与上方相同校验 -->
            <el-form-item prop="passwordagain">
              <el-input type="password" v-model="ruleForm.passwordagain" autocomplete="off" placeholder="请再次输入密码"
                prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <el-form-item prop="role">
              <div style="font-size: 14px; color: #666; margin-bottom: 8px;">选择账号类型</div>
              <el-radio-group v-model="ruleForm.role">
                <el-radio label="1">个人运动员</el-radio>
                <el-radio label="2">学校管理员</el-radio>
                <el-radio label="3">俱乐部教练</el-radio>
              </el-radio-group>
            </el-form-item>

            <!-- 底部提交按钮 -->
            <el-form-item>
              <el-button class="el-button" :class="{iscolorshow:iscolor == true }" @click="submitForm('ruleForm')"
                style="width:100%">
                注册
              </el-button>
              <!-- 下面为清空表单内容 -->
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            </el-form-item>

          </el-form>
        </el-tab-pane>
        <el-tab-pane label="组织注册" name="organazation">
          <el-form :model="organazationForm" :rules="organazationRules" ref="organazationForm">
            <!-- 组织注册方式表单div -->
            <el-form-item prop="mobile">
              <el-input v-model="organazationForm.mobile" autocomplete="off" placeholder="请输入手机号"
                prefix-icon="el-icon-user-solid"></el-input>
            </el-form-item>
            <!-- 待定义 -->
            <el-form-item prop="password">
              <el-input type="password" v-model="organazationForm.password" autocomplete="new-password"
                placeholder="请输入6-14位数字与字母密码" prefix-icon="el-icon-lock"></el-input>
            </el-form-item>
            <!-- 待增加与上方相同校验 -->
            <el-form-item prop="passwordagain">
              <el-input type="password" v-model="organazationForm.passwordagain" autocomplete="off"
                placeholder="请再次输入密码" prefix-icon="el-icon-lock"></el-input>
            </el-form-item>

            <!-- 底部提交按钮 -->
            <el-form-item>
              <el-button class="el-button" :class="{iscolorshow:iscolor == true }"
                @click="submitForm('organazationForm')" style="width:100%">
                注册
              </el-button>
              <!-- 下面为清空表单内容 -->
              <!-- <el-button @click="resetForm('ruleForm')">重置</el-button> -->
            </el-form-item>

          </el-form>
        </el-tab-pane>
      </el-tabs>


      <!-- 机构注册方式 原来的版本-->
      <!-- <div class="organlogon" v-if="!titleshow"> -->
      <div class="organlogon" v-if="false">
        <div class="topinfo">
          <!-- <p>请您下载附件，准备材料，联系我们注册</p> -->
          <p>请您联系我们，提交所需材料，完成注册</p>
        </div>
        <!-- <div class="linka">
        <a href="@/assets/file/infoload.txt" download="附件" >附件下载</a>
      </div> -->
        <div class="vx">
          <h3>微信</h3>
          <div><img src="@/assets/css/img/logonimgcode.jpg" alt="二维码"></div>
        </div>
        <div class="mobileifo">
          <h3>手机</h3>
          <h3>18540284756</h3>
        </div>
        <div class="email">
          <h3>邮件</h3>
          <h3>zhangguoqiang@chesscoacher.com</h3>
        </div>



      </div>

    </div>


  </div>

</template>

<script>
  import request from '../utils/request';
  export default {
    data() {
      // 个人注册方式校验汇总
      // 手机号自定义校验
      var validatemobile = (rule, value, callback) => {
        let str = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
        if (value === '') {
          callback(new Error('请输入手机号'));
        }
        if (str.test(value) == false) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
          return "ok"
        }
      };
      // 个人短信验证码自定义校验
      var validatesenditwo = (rule, value, callback) => {
        if (!this.ruleForm.sendi) {
          return callback(new Error('请先输入图形验证码'));
        }
        if (!value) {
          return callback(new Error('请输入短信验证码'));
        }
        if (value.length !== 4) {
          callback(new Error('请输入正确的短信验证码'));
        } else {
          callback();
        }
      };
      // 组织短信验证码自定义校验
      var orgvalidatesenditwo = (rule, value, callback) => {
        if (!this.organazationForm.sendi) {
          return callback(new Error('请先输入图形验证码'));
        }
        if (!value) {
          return callback(new Error('请输入短信验证码'));
        }
        if (value.length !== 4) {
          callback(new Error('请输入正确的短信验证码'));
        } else {
          callback();
        }
      };
      // 密码自定义校验
      var validatepassword = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        }
        if (value.length < 6 || value.length > 14) {
          callback(new Error('请输入6-14位密码'));
        }
        if (value == "111111" || value == "666666" || value == "000000" || value == "123456") {
          callback(new Error('密码强度过低，请更换'));
        } else {
          callback();
        }
      };
      // 再次密码自定义校验
      var validatepasswordagain = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        }
        if (value !== this.ruleForm.password) {
          callback(new Error('两次密码输入不一致'));
        } else {
          callback();
        }
      };
      // 组织再次密码自定义校验
      var orgvalidatepasswordagain = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        }
        if (value !== this.organazationForm.password) {
          callback(new Error('两次密码输入不一致'));
        } else {
          callback();
        }
      };
      // 图形验证码自定义校验
      var validatesendi = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入图形验证码'));
        }
        if (value !== this.ruleForm.captchaCode) {
          return callback(new Error('请输入正确的图形验证码'));
        } else {
          callback();
          return "ok"
        }
      };
      // 组织图形验证码自定义校验
      var orgvalidatesendi = (rule, value, callback) => {
        if (!value) {
          return callback(new Error('请输入图形验证码'));
        }
        if (value !== this.organazationForm.captchaCode) {
          return callback(new Error('请输入正确的图形验证码'));
        } else {
          callback();
          return "ok"
        }
      };

      return {
        // titleshow : true,
        // changeshow : true,
        activeName: 'user',
        sended: false, //是否显示验证码已发送状态
        countdown: 60, //短信验证码倒计时
        notsendi: false, //短信验证码是否可发送获取
        timer: null, // 定时器（卸载时销毁 置空）
        logoninfo: "", //注册返回的信息
        iscolor: false, // 是否更改按钮颜色 （通过表单验证则更改按钮颜色）
        ruleForm: {
          //表单数据
          mobile: '',
          senditwo: "", //短信验证码
          password: '',
          passwordagain: "", //再一次输入密码
          sendi: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传
          role: '1', //账号类型 1个人运动员 2学校管理员 3俱乐部教练
          captchaCode: "", //正确的图形验证码 用于校验
        },
        organazationForm: {
          //表单数据
          mobile: '',
          senditwo: "", //短信验证码
          password: '',
          passwordagain: "", //再一次输入密码
          sendi: '', //图形验证码 用于表单提交
          sendiimg: "", //图形验证码图片
          uuid: "", //获取短信验证码时需回传
          captchaCode: "", //正确的图形验证码 用于校验
        },

        rules: {
          // 表单数据校验规则
          mobile: [{
            validator: validatemobile,
            trigger: 'blur'
          }],
          // 短信验证码
          senditwo: [{
            validator: validatesenditwo,
            trigger: 'blur'
          }],
          password: [{
            validator: validatepassword,
            trigger: 'blur'
          }],
          passwordagain: [{
            validator: validatepasswordagain,
            trigger: 'blur'
          }],
          // 验证码
          sendi: [{
            validator: validatesendi,
            trigger: 'blur'
          }],

        },
        organazationRules: {
          // 表单数据校验规则
          mobile: [{
            validator: validatemobile,
            trigger: 'blur'
          }],
          // 短信验证码
          senditwo: [{
            validator: orgvalidatesenditwo,
            trigger: 'blur'
          }],
          password: [{
            validator: validatepassword,
            trigger: 'blur'
          }],
          passwordagain: [{
            validator: orgvalidatepasswordagain,
            trigger: 'blur'
          }],
          // 验证码
          sendi: [{
            validator: orgvalidatesendi,
            trigger: 'blur'
          }],

        },

      };
    },
    destroyed() {
      // 清除定时器
      clearTimeout(this.timer)
      this.timer = null
    },
    created() {
      // 页面初始化时 获取图形验证码
      this.getimgcode()
    },
    watch: {
      "ruleForm": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.ruleForm.mobile) && this.ruleForm.password.length > 5 && this.ruleForm
            .passwordagain == this.ruleForm.password && this.ruleForm.senditwo.length == 4 && this.ruleForm.sendi ==
            this.ruleForm.captchaCode) {
            this.iscolor = true
          } else {
            this.iscolor = false
          }
        }
      },
      "organazationForm": {
        deep: true,
        handler(newValue, oldValue) {
          // 判断是否通过校验 通过则将动态类名触发
          if (/^[1][3,5,7,8][0-9]{9}$/.test(this.organazationForm.mobile) && this.organazationForm.password.length >
            5 && this.organazationForm
            .passwordagain == this.organazationForm.password && this.organazationForm.senditwo.length == 4 && this
            .organazationForm.sendi ==
            this.organazationForm.captchaCode) {
            this.iscolor = true
          } else {
            this.iscolor = false
          }
        }
      },
    },
    methods: {
      // 更改注册方式事件
      // changetry(){

      //   this.changeshow = !this.changeshow,
      //   this.titleshow = !this.titleshow
      // },
      // 获取图形验证码
      async getimgcode() {
        const {
          data
        } = await request({
          method: "GET",
          url: `/captchaImage`,
        })
        console.log(`图形验证码：${data.captchaCode}`)
        // console.log(`图形验证码：${data.img}`)
        this.ruleForm.sendiimg = `data:image/jpg;base64,${data.img}`
        this.ruleForm.uuid = data.uuid
        this.ruleForm.captchaCode = data.captchaCode

        this.organazationForm.sendiimg = `data:image/jpg;base64,${data.img}`
        this.organazationForm.uuid = data.uuid
        this.organazationForm.captchaCode = data.captchaCode
      },
      // 获取短信验证码事件
      async getmobilecode() {
        // 判断手机号 图形验证码是否输入正确 正确才发请求 
        // 重新判断校验的内容
        if (this.ruleForm.mobile.length == "11" && /^[1][3,5,7,8][0-9]{9}$/.test(this.ruleForm.mobile) && this
          .ruleForm.sendi == this.ruleForm.captchaCode) {
          // if( this.validatemobile && this.validatesendi ){
          this.notsendi = false
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/sendPhoneCaptcha`,
            params: {
              phoneNumber: this.ruleForm.mobile,
              captchaCode: this.ruleForm.sendi,
              uuid: this.ruleForm.uuid
            }
          })
          // 调用倒计时函数
          this.settime()
          this.notsendi = true //不可获取 设置为已发送状态

        } else { //失败提示消息
          this.$alert('请完善正确的手机号或图形验证码', '提示', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }

      },

      // 组织机构获取短信验证码事件
      async getOrgmobilecode() {
        // 判断手机号 图形验证码是否输入正确 正确才发请求 
        // 重新判断校验的内容
        if (this.organazationForm.mobile.length == "11" && /^[1][3,5,7,8][0-9]{9}$/.test(this.organazationForm
            .mobile) && this
          .organazationForm.sendi == this.organazationForm.captchaCode) {
          // if( this.validatemobile && this.validatesendi ){
          this.notsendi = false
          const {
            data
          } = await request({
            method: "POST",
            url: `/common/sendPhoneCaptcha`,
            params: {
              phoneNumber: this.organazationForm.mobile,
              captchaCode: this.organazationForm.sendi,
              uuid: this.organazationForm.uuid
            }
          })
          // 调用倒计时函数
          this.settime()
          this.notsendi = true //不可获取 设置为已发送状态

        } else { //失败提示消息
          this.$alert('请完善正确的手机号或图形验证码', '提示', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }

      },
      // 倒计时函数
      settime() {

        // 逻辑： 只有当定时器走完60s
        if (this.countdown == 0) {
          this.notsendi = false
          this.sended = false
          // this.$refs.sendout.innerHTML = "获取验证码"
          this.countdown = 60
          return
        } else {
          this.notsendi = true
          this.sended = true
          // this.$refs.sendout.innerHTML = `${this.countdown}后重新获取`
          this.countdown--
        }
        let that = this
        // 外层函数内部的this是vue实例
        this.timer = setTimeout(function () {
          // 内层函数的this是调用者 不是vue实例了(这里就是window)
          that.settime()
          // console.log("开启定时器")
        }, 1000)
      },


      //注册表单提交事件
      submitForm(formName) {
        let params = {}
        if (formName == 'ruleForm') {
          params = {
            "account": this.ruleForm.mobile,
            "password": this.$md5(this.ruleForm.password),
            "type": 1,
            "role": this.ruleForm.role,
          }
        }
        if (formName == 'organazationForm') {
          params = {
            "account": this.organazationForm.mobile,
            "password": this.$md5(this.organazationForm.password),
            "type": 2,
          }
        }

        this.$refs[formName].validate(async (valid) => {

          if (valid) {
            // 发起请求 传送表单数据
            // 提示成功
            const {
              data
            } = await request({
              method: "POST",
              url: `/customer/register`,
              params: params
            })
            console.log(data)
            this.logoninfo = data
            // 判断是否请求成功
            if (this.logoninfo.code == 500) {
              if (this.logoninfo.msg === '该账号已存在') {
                this.$alert('账号已存在', {
                  confirmButtonText: '确定',
                  center: true,
                  confirmButtonClass: "el-button--success",
                });

              } else {
                this.$alert('手机验证码错误', {
                  confirmButtonText: '确定',
                  center: true,
                  confirmButtonClass: "el-button--success",
                });
              }
            } else if (this.logoninfo.code == 200) {
              this.$alert('注册成功,已登录', {
                confirmButtonText: '确定',
                center: true,
                confirmButtonClass: "el-button--success",
              });
              // 关闭弹层  子传父
              this.$emit("closelogon", false)
              // 登录 
              this.submitFormlogin(formName)
              // 清空表单值
              //表单重置内容事件
              // resetForm(formName) {
              //   this.$refs[formName].resetFields();
              // }
              //在注册成功事件里 关闭弹层
              // this.$parent.dialoglogonVisible = false  
            }


          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 账号密码登录事件 (注册成功后自动登录)
      async submitFormlogin(formName) {
        let params = {}
        if (formName == 'ruleForm') {
          params = {
            "account": this.ruleForm.mobile,
            "password": this.$md5(this.ruleForm.password),
            "type": 1,
          }
        }
        if (formName == 'organazationForm') {
          params = {
            "account": this.organazationForm.mobile,
            "password": this.$md5(this.organazationForm.password),
            "type": 2,
          }
        }
        // 发起请求 传送表单数据
        const {
          data
        } = await request({
          method: "POST",
          url: `/customer/login`,
          params: params
        })
        console.log("获取账号及用户信息成功")
        console.log(data.data)
        if (data.code == 200) {
          // 将token存入vuex 
          this.$store.commit("savetoken", true)
          // 将数据存到vuex
          // 账号信息
          this.$store.commit("updateaccountInfo", data.data.accountInfo)
          // 用户信息
          this.$store.commit("updatepersonInfo", data.data.personInfo || {})
          // 机构信息
          this.$store.commit("updateorganInfo", data.data.orgInfo || {})
          // 用户和机构 只有有一个有值  所以要进行判断  不然underfind点任何数据都会报错 找不到
          if (data.data.personInfo) {
            // 通过id获取用户信息 并存到vuex中
            this.getpersoninfoall(data.data.personInfo.id || "")
          } else if (data.data.orgInfo) {
            // 通过id获取机构信息 并存到vuex中
            this.getorganinfo(data.data.orgInfo.id || "")
          }
          // 关闭弹层 跳转首页之前 先将滚动置0 防止进入首页时出现闪白情况
          // document.documentElement.scrollTop = 0    //登录先不做  因为无论怎样都会闪白
          // 关闭弹层  子传父 (父组件处理登未登录显示状态)
          // this.$emit("closelogin",false)
          // 路由跳转至首页
          // this.$router.push({
          //   path: '/'
          // })
          // 如果是个人注册登录跳到选手信息，如果是组织注册登录跳到组织信息
          if (data.data.accountInfo.type == 1) {
            this.$router.push({
              path: '/infostartperson/playerinfo'
            })
          }
          if (data.data.accountInfo.type == 2) {
            this.$router.push({
              path: '/infostart/update'
            })
          }
        } else {
          this.$alert('登录异常，请重新登录', {
            confirmButtonText: '确定',
            center: true,
            confirmButtonClass: "el-button--success",
          });
        }
      },
      // 获取个人用户信息(存入vuex)
      async getpersoninfoall(id) {
        const {
          data
        } = await request({
          url: "/customer/PersonalUserInfo/getInfo",
          method: "POST",
          params: {
            personId: id,
          }
        })
        console.log("登录id用户信息请求成功")
        console.log(data.data)
        // 将数据存到vuex中
        this.$store.commit("updatepersonInfo", data.data || {})
      },
      // 获取机构用户信息(存入vuex)
      async getorganinfo(id) {
        const {
          data
        } = await request({
          url: "/customer/OrgUserInfo/getInfo",
          method: "POST",
          params: {
            orgId: id,
          }
        })
        console.log("登录id机构信息请求成功")
        console.log(data.data)
        // 将数据存到vuex中
        this.$store.commit("updateorganInfo", data.data || {})
      },
      //表单重置内容事件 暂不需要
      // resetForm(formName) {
      //   this.$refs[formName].resetFields();
      // }
    }
  }

</script>

<style lang="less" scoped>
  .title {
    font-size: 30px;
    font-weight: bold;
    display: flex;
  }

  .change {
    font-size: 26px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }

  /deep/.el-input__inner {
    // background-color: #F1F0F6 !important;
    background: #EDEFFF;
    // border-radius: 12px;
    border: 2px solid #4C65FF;
  }

  /deep/.el-input__inner:hover {
    background: #ffffff;
    border: 2px solid #4C65FF;
  }

  /deep/.el-button {
    // background-color: #F1F0F6 !important;
    background: #EDEFFF;
    color: #333333;
    font-weight: bold;
    height: 60px;
    font-size: 26px;
    border: 2px solid #4C65FF;
    // border: none;
  }

  /deep/.el-button:hover {
    background: #ffffff;
    // color: #409EFF;
    border: 2px solid #4C65FF;
    // background-color: #ecf5ff;
  }

  .vidid {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .vidi {
    // width:190px;
    // height: 80px;
    background: #D8D8D8;
    display: inline-block;
    margin-left: 20px;
  }

  .short {
    position: fixed;
    margin-top: 24px;
    margin-right: 40px;
  }

  .vididd {
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  //  发送短信验证码按钮

  .send {
    width: 240px;
    height: 40px;
    line-height: 36px;
    border-radius: 10px;
    margin-left: 20px;
    font-size: 18px;
    color: #333333;
    padding: 0px 25px;
  }

  // 机构注册 样式
  .organlogon {
    margin-left: 0px;
    // display: flex;
    // justify-content: flex-start;
  }

  .organlogon a {
    font-size: 22px;
    color: #449D44;
    text-decoration: underline;
  }

  .organlogon h3 {
    font-size: 22px;
  }

  .topinfo {
    font-size: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 40px;
  }

  .linka {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }


  .vx {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 50px;
    margin-bottom: 40px;
  }

  .vx div {
    width: 104px;
    height: 97px;
    background: green;
    margin-left: 20px;
  }

  .vx img {
    width: 104px;
    height: 97px;
  }

  .mobileifo {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .mobileifo h3:last-child {
    margin-left: 20px;
  }

  .email {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 40px;
    margin-bottom: 50px;
  }

  .email h3:last-child {
    margin-left: 20px;
  }

  // 表单通过验证后 按钮更换的样式
  /deep/.iscolorshow {
    background-color: #2C9382 !important;
    color: white;
  }

</style>
